import { useContext } from 'react'

import { PriceContext } from '@/providers/PriceContextProvider'

import type { PriceContextProviderProps } from '@/providers/PriceContextProvider'

export const usePriceContext = (): PriceContextProviderProps => {
  const context = useContext(PriceContext)
  if (context === undefined) {
    throw new Error('usePriceContext must be used within a PriceContextProvider')
  }

  return context
}
